import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'

const retornaLocalAtendimento = (u = []) => ({
  idAgente: u?.[0] || undefined,
  nmAgente: u?.[1] || '',
  cdModelo: u?.[2] || '',
  dsPrompt: u?.[3] || '',
  nrTemperatura: u?.[4] || '',
})

const Edicao = ({ dados, voltar }) => {
  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <Formik
      initialValues={retornaLocalAtendimento(dados)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={1}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="idAgente"
                label="Código"
                disabled
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={11}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="nmAgente"
                label="Nome"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="cdModelo"
                label="Modelo"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="nrTemperatura"
                label="Temperatura"
                fullWidth
                margin="dense"
                variant="outlined"
                type="number"
                inputProps={{
                  step: '0.01',
                  min: '0',
                  max: '2',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dsPrompt"
                label="Prompt"
                multiline
                minRows={5}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
